import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface ICustomerStrings extends LocalizedStringsMethods {
    lsHomeTxt: string;    
    lsOrgsTxt: string;
    lsManageOrgTxt: string;
    lsAddOrgTxt: string;
    lsUploadOrgTxt: string;
    lsActiveOrgTxt: string;
    lsInactiveOrgTxt: string;
    lsAllOrgTxt: string;
    lsNameTxt: string;
    lsContactFirstNameTxt: string;    
    lsContactLastNameTxt: string;
    lsContactPhoneTxt: string;
    lsContactEmailTxt: string;    
    lsEditTxt: string;
    lsDeactivateTxt: string;
    lsTotalTxt: string;
    lsActivateTxt: string;
    lsOrgFilterTxt: string;
    lsFilterTxt: string;
    lsTotalOrgTxt: string;
    lsAction: string;
    lsNoFilterTxt: string;
    lsClearFilterTxt: string;
    lsDwnldTxt: string;
    lsExportOrgTxt: string;
    lsExportOrgSuccessTxt: string;
    lsOkTxt: string;    
    lsPrintTxt: string;
    lsOrgListFilterTxt: string;
    lsCSVTxt: string;
    lsCustomerActivationSuccessTxt: string;
    lsViewTxt: string;
}

let strings: ICustomerStrings;
export default strings = new LocalizedStrings({
    en: {
        lsHomeTxt: 'Home',
        lsOrgsTxt: 'Customers',
        lsManageOrgTxt: 'Manage Customers',
        lsAddOrgTxt: 'Add New Customer',
        lsUploadOrgTxt: 'Upload New Customers',
        lsActiveOrgTxt: 'Active Customers',
        lsInactiveOrgTxt: 'Inactive Customers',
        lsAllOrgTxt: 'All Customers',
        lsNameTxt: 'Name',
        lsContactFirstNameTxt: 'Contact First Name',    
        lsContactLastNameTxt: 'Contact Last Name',
        lsContactPhoneTxt: 'Contact Phone',
        lsContactEmailTxt: 'Contact Email',    
        lsEditTxt: 'Edit',
        lsDeactivateTxt: 'Deactivate',
        lsTotalTxt: 'Total',
        lsActivateTxt: 'Activate',
        lsOrgFilterTxt: 'Customer List Filter',
        lsFilterTxt: 'Filter',
        lsTotalOrgTxt: 'Total {0} Customers',
        lsAction: 'Action',
        lsNoFilterTxt: 'No filters applied',
        lsClearFilterTxt: 'Clear Filters',
        lsDwnldTxt: 'Download',
        lsExportOrgTxt: 'Export Customer List',        
        lsExportOrgSuccessTxt: 'Customers exported successfully without tests!',
        lsOkTxt: 'Ok',    
        lsPrintTxt: 'Print',
        lsOrgListFilterTxt: 'Customer List Filter',
        lsCSVTxt: 'CSV',
        lsCustomerActivationSuccessTxt: 'Customer {0} successfully!',
        lsViewTxt: 'View'
    },
    es: {
        lsHomeTxt: 'Casa',
        lsOrgsTxt: 'Clientes',
        lsManageOrgTxt: 'Administrar Clientes',
        lsAddOrgTxt: 'Añadir nuevo cliente',
        lsUploadOrgTxt: 'Subir nuevas clientes',
        lsActiveOrgTxt: 'Clientes activas',
        lsInactiveOrgTxt: 'Clientes inactivas',
        lsAllOrgTxt: 'Todas las clientes',
        lsNameTxt: 'Nombre',
        lsContactFirstNameTxt: 'Nombre de pila de contacto',    
        lsContactLastNameTxt: 'Apellido de contacto',
        lsContactPhoneTxt: 'teléfono de contacto',
        lsContactEmailTxt: 'Email de contacto',    
        lsEditTxt: 'Editar',
        lsDeactivateTxt: 'Desactivar',
        lsTotalTxt: 'Total',
        lsActivateTxt: 'Activar',
        lsOrgFilterTxt: 'Filtro de lista de cliente',
        lsFilterTxt: 'Filtrar',
        lsTotalOrgTxt: 'Total {0} clientes',
        lsAction: 'Acción',
        lsNoFilterTxt: 'No se aplicaron filtros',
        lsClearFilterTxt: 'Borrar filtros',
        lsDwnldTxt: 'Descargar',
        lsExportOrgTxt: 'Lista de clientes de exportación',        
        lsExportOrgSuccessTxt: '¡Las clientes se exportan exitosamente sin pruebas!',
        lsOkTxt: 'De acuerdo',    
        lsPrintTxt: 'Impresión',
        lsOrgListFilterTxt: 'Customer List Filter',
        lsCSVTxt: 'CSV',
        lsCustomerActivationSuccessTxt: 'Cliente {0} successfully!',
        lsViewTxt: 'View'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/customer/strings.customer.tsx